import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const NURSING_PATH = "/consultation/v1/nursingAssessment";

export const addNursingAssessmentApi = async (body) =>
  await postRequest(NURSING_PATH, body);

export const deleteNursingAssessmentByIdApi = async (id) =>
  await deleteRequest(`${NURSING_PATH}/${id}`);
